/* eslint-disable prettier/prettier */
import { HealthRepository } from '../infrastructure/HealthRepository';

export class HealthService {
    constructor() {
        this.repository = new HealthRepository();
    }

    async getHealthStatus(region) {
        try {
            const healthData = await this.repository.fetchHealthStatus(region);

            if (!healthData || typeof healthData !== 'object') {
                throw new Error('無效的健康狀態數據');
            }

            return healthData;
        } catch (error) {
            console.error('Error in HealthService:', error);

            if (error instanceof Error) {
                throw error;
            } else {
                throw new Error('獲取健康狀態時發生未知錯誤');
            }
        }
    }
}